import { Component, OnInit } from '@angular/core';
import { NgsRevealConfig } from 'ngx-scrollreveal';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [NgsRevealConfig]
})

export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
